class AoraTransparentHeader {
  constructor() {
    this.header = document.querySelector('[data-aora-transparent-header]');
    if (!this.header || this.header.dataset.aoraHeaderReady === 'true') return;

    this.header.dataset.aoraHeaderReady = 'true';
    this.ticking = false;
    this.drawerDetails = this.header.querySelector('#Details-menu-drawer-container');

    this.update = this.update.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onDrawerToggle = this.onDrawerToggle.bind(this);

    this.update();
    this.onDrawerToggle();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.drawerDetails?.addEventListener('toggle', this.onDrawerToggle);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  onDrawerToggle() {
    const open = Boolean(this.drawerDetails?.open);
    this.header.classList.toggle('is-menu-open', open);
  }

  update() {
    this.header.classList.toggle('is-scrolled', window.scrollY > 25);
  }
}

function initAoraHeader() {
  new AoraTransparentHeader();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAoraHeader);
} else {
  initAoraHeader();
}

document.addEventListener('shopify:section:load', (event) => {
  const header = event.target?.querySelector?.('[data-aora-transparent-header]') || document.querySelector('[data-aora-transparent-header]');
  if (header) delete header.dataset.aoraHeaderReady;
  initAoraHeader();
});
